<template>
  <div class="import-file">
    <div class="title">
      <i class="el-icon-warning" />
      为了确保上传数据与列表内容匹配，请先<span class="color-theme" @click="handleDownloadFile">下载示例文件</span>
    </div>
    <div v-if="fileList.length>0" class="file-list">
      <div class="name">
        <i class="el-icon-s-goods" />
        {{ fileList[0].file.name }}
      </div>
      <div class="delete" @click="handleDelete">
        删除
      </div>
    </div>
    <el-upload
      v-loading="loading"
      :class="fileList.length?'border1':'border2'"
      drag
      action="string"
      :accept="accept"
      :limit="1"
      :file-list="fileList"
      :show-file-list="false"
      :on-progress="handleUploadProgress"
      :before-upload="handleBeforeUpload"
      :on-exceed="handleUploadExceed"
      :http-request="httpRequest"
      :headers="headers"
    >
      <div class="el-upload__text flex-info">
        <i class="el-icon-upload2" />
        <div class="text">
          添加文件
        </div>
      </div>
      <div class="el-upload__text desc-info">
        支持.xlsx格式文件，单次导入数据量500，不含表头。
      </div>
    </el-upload>
    <div class="btns-wrap">
      <el-button @click="handleCancle">
        取消
      </el-button>
      <el-button type="primary" @click="handleSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { localStorageGet } from '@/utils/localStorage';
import { TOKEN, USER } from '@/constant/storage';
import { uploadControlInformation } from '@/api/userControl';

const type = ['xls', 'xlsx'];

export default {
  data() {
    return {
      accept: '.xls, .xlsx',
      fileList: [],
      loading: false, // 加载状态
      headers: {
        Authorization: localStorageGet(TOKEN),
      },
      userInfo: localStorageGet(USER),
      formData: null,
    };
  },
  methods: {
    handleDownloadFile() {
      const url = 'https://ylzapp-pub-test.oss-cn-zhangjiakou.aliyuncs.com/1004/common_exporter/1691491062015/批量管控导入模板.xlsx';
      const a = document.createElement('a');
      a.setAttribute('href', url);
      document.body.appendChild(a);
      a.click();
    },
    handleBeforeUpload(file) {
      const fileName = file.name;
      const index = fileName.lastIndexOf('.');
      const suffix = fileName.substring(index + 1, fileName.length);
      if (!type.includes(suffix)) {
        this.$message.error('请导入xlsx格式的文件');
        return false;
      }
      return true;
    },
    handleUploadExceed() {
      // 文件超出限制
      this.$message.error('请删除后现有附件后重新上传');
    },
    httpRequest(res) {
      this.fileList = [{ file: res.file }];
      const formData = new FormData();
      formData.append('file', res.file);
      formData.append('businessType', 'CONTROL_EQU_FILE_UPLOAD');
      formData.append('userName', this.userInfo?.realName);
      formData.append('userId', this.userInfo?.userId);
      this.formData = formData;
      this.loading = false;
    },
    handleUploadProgress() {
      this.loading = true;
    },
    handleDelete() {
      this.fileList = [];
      this.formData = null;
    },
    handleCancle() {
      this.$emit('closeDialog', {
        needRefresh: false,
      });
    },
    async handleSubmit() {
      if (!this.fileList.length) {
        this.$message.error('请先上传文件');
      }
      await uploadControlInformation(this.formData);
      this.$message.success('导入成功，请稍后点击查看导入日志查看结果');
      this.$emit('closeDialog', {
        needRefresh: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.title{
  width: 520px;
  height: 48px;
  line-height: 48px;
  background: #F3F7FC;
  border-radius: 4px;
  border: 1px solid #99BFE9;
  box-sizing: border-box;
  color:#323233;
  margin-bottom: 12px;
  .el-icon-warning{
    color:#0A69D1 ;
    font-size: 20px;
    padding:0 9px 0 16px
  }
  .color-theme{
    color:#059E84;
    cursor: pointer;
  }
}
::v-deep .el-upload-dragger{
  height: 80px;
  width: 520px;
  border:none;
}
.flex-info{
  display: flex;
  color: #323233;
  justify-content: center;
  align-items: center;
  margin:16px 0 8px 0;
  .el-icon-upload2{
    color:#059E84
  }
}
.desc-info{
  color: #969799;
  font-size: 12px;
}
.btns-wrap{
  text-align: right;
  padding-top: 20px;
}
::v-deep .border1{
  .el-upload-dragger{
    border: 1px solid #DCDEE0;
  }
}
::v-deep .border2{
  .el-upload-dragger{
    border: 1px solid #DCDEE0;
    border-radius: 0px 0px 4px 4px
  }
}
.file-list{
  padding:9px 16px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  height: 32px;
  align-content: center;
  font-size: 14px;
  color: #323233;
  border: 1px solid #DCDEE0;
  border-bottom: 0;
  border-radius:  4px 4px 0 0;
  .el-icon-s-goods{
    color:#059E84 ;
  }
  .delete{
    color: #059E84 ;
    cursor: pointer;
  }
}
</style>
